import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatPurchaseAmendmentStatusLabel } from '#/modules/srmMgmt/purchaseOrder/helper/purchaseAmendmentStatus';

const PurchaseAmendmentStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatPurchaseAmendmentStatusLabel(status)}
    size={size}
    className={className}
  />
);

PurchaseAmendmentStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default PurchaseAmendmentStatusBadge;
